import React, { Fragment } from "react";
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png';
import SEO from '../../components/SEO/SEO';
import { seoData } from '../../utils/seoData';
import "./industries.scss";

const industriesData = [
  {
    id: 1,
    name: "Chemical Industry",
    title: "Raw & Specialty Chemicals",
    img: "/images/industries/chemical.jpg",
    desc:
      "We supply high-purity industrial chemicals essential for chemical manufacturing, formulation, and processing. Our products support various operations including pH regulation, neutralization, catalysis, purification, and raw material production for downstream chemicals."
  },
  {
    id: 2,
    name: "Pharmaceuticals & Healthcare",
    title: "Pharma-Grade Ingredients",
    img: "/images/industries/pharma.jpg",
    desc:
      "Our chemicals play an important role in pharmaceutical intermediates, purification processes, API manufacturing, and quality control operations. We ensure consistent quality and industry compliance to meet the demanding standards of pharma and healthcare sectors."
  },
  {
    id: 3,
    name: "Water Treatment",
    title: "Filtration & Treatment Solutions",
    img: "/images/industries/water.jpg",
    desc:
      "We provide chemical solutions for municipal water treatment plants, industrial effluent treatment (ETP), sewage treatment (STP), and environmental purification systems. Our products help remove impurities, reduce hardness, control pH, and ensure safe discharge compliance."
  },
  {
    id: 4,
    name: "Steel Industry",
    title: "Construction & Civil Chemicals",
    img: "/images/industries/steel.jpg",
    desc:
      "Our chemical solutions are widely used in steel pickling, surface treatment, metal purification, flotation, and mineral processing. Products like hydrochloric acid and activated carbon support descaling, refining, and recovery processes in metal and mining industries."
  },
  {
    id: 5,
    name: "Drilling Industry",
    title: "Drilling Fluids & Additives",
    img: "/images/industries/drilling.jpg",
    desc:
      "We provide specialized chemicals for oil and gas drilling operations, including drilling mud additives, pH control agents, and filtration solutions. Our products enhance drilling efficiency, wellbore stability, and fluid performance in challenging drilling environments."
  },
  {
    id: 6,
    name: "Textile Industry",
    title: "Textile Processing Chemicals",
    img: "/images/industries/textile.jpg",
    desc:
      "Our chemicals support dyeing, bleaching, pH adjustment, color removal, and wastewater treatment in textile and leather manufacturing. They enhance dye uptake, improve processing efficiency, and ensure environmentally safe operations."
  }
];

export default function IndustriesPage() {
  return (
    <Fragment>
      <SEO title={seoData.industries.title} description={seoData.industries.description} keywords={seoData.industries.keywords} />
      <Navbar Logo={Logo} />
      <PageTitle pageTitle={'Industries'} pagesub={'Industries'} customClass={'industries-page-banner'} />
      <section className="industries-page">
        <div className="container">
          <header className="header">
            <h1>Industries We Serve</h1>
            <p>Custom-engineered chemical solutions tailored for diverse sectors.</p>
          </header>

          <div className="grid">
            {industriesData.map((ind) => (
              <div className="industry-block" key={ind.id}>
                <div className="image-section">
                  <img src={ind.img} alt={ind.name} />
                </div>
                <div className="content-section">
                  <h2>{ind.name}</h2>
                  <h3>{ind.title}</h3>
                  <p>{ind.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
